<template lang="html">
  <div class="vh-100 overflow-y-scroll">
    <!-- Back Button -->
    <div class="ma2">
      <pl-button @click.native="$router.go(-1)" class="pl-primary">
        Go back
      </pl-button>
    </div>

    <!-- Main Content -->
    <div class="ma4 mw8 center">
      <h1>Teacher: {{ user.name }}</h1>
      <h1>Email: {{ user.email }}</h1>
      <h1>
        Role: {{ user.role }}
        <pl-button @click.native="changeUserRole" class="pl-primary">
          Change to
          {{ user.role === 'teacher' ? 'student' : 'teacher' }}
        </pl-button>
      </h1>
      <br /><br />

      <!-- Teacher only section -->
      <template v-if="user.role === 'teacher'">
        <h2>Active Memberships</h2>
        <ul>
          <li class="pl-subheading" v-for="membership in active_memberships">
            <strong>Expiry Date</strong>: {{ membership.end_date_readable }}
            <br />
            <strong>Date Started</strong>: {{ membership.start_date_readable }}
            <br />
            <strong>Membership Type</strong>: {{ membership.membership.type }}
          </li>
        </ul>

        <h2>Previous (Expired) Memberships</h2>
        <ul>
          <li class="pl-subheading" v-for="membership in expired_memberships">
            <strong>Expiry Date</strong>: {{ membership.end_date_readable }}
            <br />
            <strong>Date Started</strong>: {{ membership.start_date_readable }}
            <br />
            <strong>Membership Type</strong>: {{ membership.membership.type }}
          </li>
        </ul>

        <!-- Create new Membership -->
        <h2>Create New Membership</h2>

        <!-- Membership Date Picker -->
        <fieldset>
          <legend>Choose Membership Duration</legend>

          <div>
            <label for="start">Start Date</label>
            <input
              v-model="start_date"
              type="date"
              id="start"
              name="membership-selection"
              required
            />
          </div>

          <div>
            <label for="end">End Date</label>
            <input
              v-model="end_date"
              type="date"
              id="end"
              name="membership-selection"
              required
            />
          </div>
        </fieldset>

        <!-- Create New Membership Button -->
        <div>
          <pl-button
            :disabled="Boolean(!(start_date && end_date))"
            class="pl-primary"
            @click.native="createNewUserMembership"
          >
            Create New
          </pl-button>
        </div>

        <h2>Activity Passes</h2>
        <div class="pl-subheading">
          <div>Current Unused passes: {{ user.activity_passes }}</div>
          <input v-model="passes_to_create" type="number" min="1" />
          <pl-button @click.native="createActivityPasses" class="pl-primary">
            Create More
          </pl-button>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  import adminServices from 'services/admin/adminServices';

  import moment from 'moment';

  export default {
    data() {
      return {
        user: {
          user_memberships: [],
          activity_passes: 0,
          role: 'student',
        },
        passes_to_create: 1,
        start_date: '',
        end_date: '',
      };
    },
    computed: {
      userID() {
        return this.$route.params.userID;
      },
      expired_memberships() {
        return this.user.user_memberships.filter((membership) => {
          return moment().isAfter(membership.end_date);
        });
      },
      active_memberships() {
        return this.user.user_memberships.filter((membership) => {
          return moment().isBefore(membership.end_date);
        });
      },
    },
    methods: {
      changeUserRole() {
        const role = this.user.role === 'teacher' ? 'student' : 'teacher';
        return adminServices
          .adminUpdateUser(this.userID, { role })
          .then((res) => {
            this.user.role = res.data.role;
          });
      },
      createNewUserMembership() {
        if (!(this.start_date && this.end_date)) {
          return;
        }
        adminServices
          .upgradeTeacher(this.userID, {
            start_date: this.start_date,
            end_date: this.end_date,
          })
          .then((res) => {
            this.start_date = '';
            this.end_date = '';
            this.user.user_memberships.push(res.data);
          })
          .catch();
      },
      createActivityPasses() {
        adminServices
          .createActivityPasses(this.userID, this.passes_to_create)
          .then(() => {
            this.user.activity_passes =
              parseInt(this.user.activity_passes) +
              parseInt(this.passes_to_create);
            this.passes_to_create = 1;
          })
          .catch();
      },
    },
    mounted() {
      adminServices
        .getUser(this.userID)
        .then((res) => {
          this.user = res.data;
        })
        .catch();
    },
  };
</script>

<style lang="stylus" scoped></style>



// WEBPACK FOOTER //
// viewIndividualUser.vue?21967a84